/*
Tutorial Hero
*/

class TutorialHero extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var modalVideo = this.querySelector("site-modal video");
    if (!modalVideo) return;

    modalVideo.addEventListener("playing", function () {
      modalVideo.classList.add("is-ready");
    });

    this.querySelector(".trigger-tutorial").addEventListener("click", function () {
      modalVideo.play();
    });

    var modal = this.querySelector("site-modal .modal");

    function resetVideo() {
      modalVideo.pause();
      modalVideo.currentTime = 0;
      modalVideo.classList.remove("is-ready");
    }

    this.querySelectorAll("site-modal .modal-close").forEach(function (close) {
      close.addEventListener("click", resetVideo);
    });

    if (modal) {
      modal.addEventListener("click", function (e) {
        if (e.target === modal) {
          resetVideo();
        }
      });
    }
  }
}

customElements.define("tutorial-hero", TutorialHero);

/*
Help List
*/

class HelpList extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector("button").addEventListener("click", (e) => {
      history.pushState({}, "", "/?gs_open_chat");

      if (typeof GorgiasChat !== "undefined") {
        GorgiasChat.init().then(() => {
          GorgiasChat.open();
        });
      } else {
        console.error(
          "Gorgias chat not found. Make sure the Gorgias script is loaded."
        );
      }
    });
  }
}

customElements.define("help-list", HelpList);
